import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CfdiFiscalRegimen from './CfdiFiscalRegimen.js';
import ACCESS from '../../../ACCESS.js';

class CfdiFiscalRegimenes extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'fiscal-regimen/filter', deleteUrl: 'fiscal-regimen/delete', deleteField: 'cfdi_regimen_nombre', modUrl: '/Catalogo/CfdiFiscalRegimen' },
      TableOp.Table('Regimenes Fiscales CFDI', [
        { label: 'Clave', id: 'cfdi_regimen_clave' },
        { label: 'CfdiFiscalRegimen', id: 'cfdi_regimen_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_REGIMENES_FISCALES_CFDI.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_REGIMENES_FISCALES_CFDI.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
        {
           
          <CfdiFiscalRegimen  onSave={() => {this.table()}}></CfdiFiscalRegimen>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(CfdiFiscalRegimenes)